<div class="stick-top">
  <mat-toolbar><mat-icon>notifications_active</mat-icon> Notifications</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/notif/subscriptions/0">
      <mat-icon>add</mat-icon>
      Create a new Notification
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th style="min-width: 100px;">
        <div class="vbox">
          Group
          <micro-objectGroup-select [(objectGroupId)]="filter.groupId" type="SUBSCRIPTION"></micro-objectGroup-select>
        </div>
      </th>
      <th *ngIf="isCompanyAdmin">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId"></micro-company-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Name
          <input [(ngModel)]="filter.name">
        </div>
      </th>
      <th>
        <div class="vbox">
          Enabled
          <micro-yesNo-select [(yesNo)]="filter.enabled" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Escalation Enabled
          <micro-yesNo-select [(yesNo)]="filter.enableEscalation" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Send Task
          <micro-yesNo-select [(yesNo)]="filter.sendTask" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Send ITSM Request
          <micro-yesNo-select [(yesNo)]="filter.sendItsmRequest" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Send Email
          <micro-yesNo-select [(yesNo)]="filter.sendEmail" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Send SMS
          <micro-yesNo-select [(yesNo)]="filter.sendSms" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Send Voice
          <micro-yesNo-select [(yesNo)]="filter.sendVoice" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td><micro-objectGroup-lookup [objectGroupId]="element.groups"></micro-objectGroup-lookup></td>
      <td *ngIf="isCompanyAdmin"><micro-company-lookup [companyId]="element.companyId" [link]="false"></micro-company-lookup></td>
      <td><a routerLink="/notif/subscriptions/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.enabled ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.enableEscalation ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.sendTask ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.sendItsmRequest ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.sendEmail ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.sendSms ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.sendVoice ? 'ENABLED' : 'DISABLED'}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[25, 50, 100, 250]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
